module.exports = __webpack_public_path__ + "img/img-1.a362c0fa.png";